import React from 'react';
import PropTypes from 'prop-types';
import { BaasicButton } from 'core/components';
import { defaultTemplate } from 'core/hoc';

class AcknowledgeErrorsTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [...props.initialErrors]
        };
    }

    acknowledgeError = () => {
        this.props.onCancel();
    };

    render() {
        const { t } = this.props;
        const { errors } = this.state;

        return (
            <div>
                <div className='modal__wrap'>
                    <i style={{ cursor: "default" }} className="status--sqare modal-error u-radius--full u-mar--bottom--sml"></i>

                    {errors.map((err, index) => (
                        <p key={index} className='type--base type--wgt--semibold u-mar--bottom--med'>{err}</p>                               

                    ))}

                    <BaasicButton
                        className='btn btn--base btn--primary'
                        onClick={() => this.acknowledgeError()}
                        label={t('MODAL.ACKNOWLEDGE')}
                    />
                </div>
            </div>
        );
    }
}

AcknowledgeErrorsTemplate.propTypes = {
    initialErrors: PropTypes.arrayOf(PropTypes.string),
    t: PropTypes.func,
    onCancel: PropTypes.func
};

export default defaultTemplate(AcknowledgeErrorsTemplate);
